import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';

export default function Layout({ darkMode }) {
  return (
    <div 
      className={`${darkMode ? 'cs_dark' : ''} konf-page-bg`}
      style={{ 
        '--desktop-arkaplan': "url('/images/pc_bg.jpeg')",
        '--mobil-arkaplan': "url('/images/mobile_bg (2).jpeg')",
      }}
    >
      <Header
        logoUrl="/images/konf_logo.png"
        actionBtnText="Kayıtlar Tamamlandı"
        actionBtnUrl="#"
      />
      <Outlet />
    </div>
  );
}
